/**
 * 页面头部导航板块
 */
import request, { serverTriggerUrl } from "@/utils/fetch";

export enum NAV_APIS {
  NAVS = "/navs/global",
  CLASSES = "/classes", // 二级导航
}

// 板块 Fid
export interface ITopLevelNav {
  url: string;
  title: string;
  link_url: string;
  open_type: number;
}

/**
 * 顶级导航条目数据结构
 */
export interface TopLevelNavItem {
  node_list: ITopLevelNav[];
}

/**
 * 顶级导航接口响应结构
 */
export interface TopLevelNavResponse {
  item: TopLevelNavItem;
}

export const getNavsList = (isServerTrigger = false) => {
  const url = `${isServerTrigger ? serverTriggerUrl : ""}${NAV_APIS.NAVS}`;
  const key = "GetNavsList";
  return request({ isServerTrigger, url, key })
    .then((data: TopLevelNavResponse) => {
      return data?.item?.node_list || [];
    })
    .catch((e) => {
      return [];
    });
};
